module.exports = __webpack_public_path__ + "static/img/logo_white.1a29a698.png";